import React, { FC } from "react";

import { GuideStatus } from "@mapmycustomers/shared/enum/guides";
import Role from "@mapmycustomers/shared/types/Role";
import Team from "@mapmycustomers/shared/types/Team";

import CompletionFilter from "@app/scene/onboarding/components/CompletionFilter";
import { DateFilterValue } from "@app/scene/onboarding/types/DateUnit";

import CreationFilter from "./CreationFilter";
import QuickSearch from "./QuickSearch";
import RoleFilter from "./RoleFilter";
import TeamFilter from "./TeamFilter";
import styles from "./UsersFilterBar.module.scss";

export interface GuidesFilterBarProps {
  completionFilter?: GuideStatus;
  creationFilter?: DateFilterValue;
  onCompletionFilterChange: (status?: GuideStatus) => void;
  onCreationFilterChange: (value?: DateFilterValue) => void;
  onQuickFilterChange: (value: string) => void;
  onRoleFilterChange: (roleId?: Role["id"]) => void;
  onTeamFilterChange: (teamId?: Team["id"]) => void;
  quickFilter: string;
  roleFilter?: Role["id"];
  teamFilter?: Team["id"];
}

const UsersFilterBar: FC<GuidesFilterBarProps> = ({
  completionFilter,
  creationFilter,
  onCompletionFilterChange,
  onCreationFilterChange,
  onQuickFilterChange,
  onRoleFilterChange,
  onTeamFilterChange,
  quickFilter,
  roleFilter,
  teamFilter,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.filters}>
        <TeamFilter onChange={onTeamFilterChange} value={teamFilter} />
        <RoleFilter onChange={onRoleFilterChange} value={roleFilter} />
        <CompletionFilter onChange={onCompletionFilterChange} value={completionFilter} />
        <CreationFilter onChange={onCreationFilterChange} value={creationFilter} />
      </div>
      <div className={styles.quickSearch}>
        <QuickSearch onChange={onQuickFilterChange} value={quickFilter} />
      </div>
    </div>
  );
};

export default UsersFilterBar;
